import React, { useState } from 'react';
import Wysiwyg from '../../../../../common/components/fields/wysiwyg';
import { Card, CardContent, Paper, Tab, Tabs } from '@material-ui/core';
import { ContentTypesEnum_class } from '../../../../../common/enums/contentTypes';
import { FacilityExtraDto } from '../../../visitorInformation.dtos';
import TabPanel from '../../../../../common/components/tabPanel';

interface IProps {
  extras: FacilityExtraDto[];
  onChange: (field: string, value: any) => void;
}

const FacilityExtras: React.FC<IProps> = ({ extras, onChange }) => {
  const [tab, setTab] = useState(1);

  const handleChange = (e: React.ChangeEvent<{}>, newTab: number) => {
    setTab(newTab);
  };

  const handleContentChange = (newContent: FacilityExtraDto) => {
    const index = extras.findIndex(
      (c) => c.contentTypeId === newContent.contentTypeId
    );
    const copy = [...extras];
    copy[index] = newContent;
    onChange('content', copy);
  };

  return (
    <Card>
      <CardContent>
        <Paper square>
          <Tabs
            indicatorColor='primary'
            textColor='primary'
            value={tab}
            onChange={handleChange}
          >
            {Object.keys(ContentTypesEnum_class.enumByNumber)
              .filter((f) => isNaN(+f) === false)
              .map((o, i) => (
                <Tab
                  key={o.toString() + i}
                  label={ContentTypesEnum_class.enumByNumber[+o]}
                  value={+o}
                />
              ))}
          </Tabs>
        </Paper>
        <TabPanel index={tab} value={tab}>
          {extras
            .filter((v, i, a) => a.findIndex(v2 => v2.contentTypeId === v.contentTypeId) === i)
            .map(
            (c) =>
              c.contentTypeId === tab && (
                <Wysiwyg
                  key={c.id}
                  content={c}
                  onChange={handleContentChange}
                />
              )
          )}
        </TabPanel>
      </CardContent>
    </Card>
  );
};

export default FacilityExtras;
